import React, { useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const WARNA = [
  "rgba(51, 212, 157, 1)",
  "rgba(54, 162, 235, 1)",
  "rgba(255, 99, 132, 1)",
  "rgba(255, 193, 7, 1)",
  "rgba(153, 102, 255, 1)",
  "rgba(255, 159, 64, 1)",
];

const METRIK = [
  { id: "intensity", name: "Intensitas (per kg)" },
  { id: "total_saved", name: "Total Dihemat" },
  { id: "total", name: "Total Absolut" },
  { id: "order_count", name: "Jumlah Order" },
];

const opsi = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: { mode: "index", intersect: false },
  plugins: { legend: { position: "bottom", labels: { font: { size: 10 } } } },
  scales: { y: { beginAtZero: false } },
};

function TrenChart({ data, kode, onChangeKode, daftarKode }) {
  const [Metrik, setMetrik] = useState("intensity");

  const seri = data?.data || {};
  const labels = data?.periode || [];
  const kodeAktif = Object.keys(seri);

  // Satuan tiap indikator berbeda, jadi menggabungkan banyak indikator pada satu
  // sumbu Y hanya masuk akal untuk metrik tanpa satuan. Untuk sisanya pengguna
  // diarahkan memilih satu indikator lewat filter di atas grafik.
  const chartData = {
    labels,
    datasets: kodeAktif.map((code, i) => ({
      label: code,
      data: labels.map((p) => {
        const baris = (seri[code] || []).find((val) => val.periode === p);
        return baris ? baris[Metrik] : null;
      }),
      borderColor: WARNA[i % WARNA.length],
      backgroundColor: WARNA[i % WARNA.length],
      tension: 0.3,
      spanGaps: true,
    })),
  };

  return (
    <div>
      <div className="d-flex flex-wrap align-items-center mb-2" style={{ fontSize: "12px" }}>
        <select
          className="form-select form-select-sm me-2 mb-1"
          style={{ width: 220, fontSize: "12px" }}
          value={kode}
          onChange={(e) => onChangeKode(e.target.value)}
        >
          <option value="">Semua indikator</option>
          {(daftarKode || []).map((val) => (
            <option key={val.code} value={val.code}>
              {val.nama}
            </option>
          ))}
        </select>
        <select
          className="form-select form-select-sm mb-1"
          style={{ width: 200, fontSize: "12px" }}
          value={Metrik}
          onChange={(e) => setMetrik(e.target.value)}
        >
          {METRIK.map((val) => (
            <option key={val.id} value={val.id}>
              {val.name}
            </option>
          ))}
        </select>
      </div>

      {kodeAktif.length > 0 ? (
        <div style={{ height: 300 }}>
          <Line data={chartData} options={opsi} />
        </div>
      ) : (
        <div className="text-muted" style={{ fontSize: "12px" }}>
          Belum ada data tren.
        </div>
      )}

      {kode === "" && kodeAktif.length > 1 && (
        <div className="text-muted mt-2" style={{ fontSize: "10px" }}>
          Beberapa indikator memakai satuan berbeda. Pilih satu indikator bila
          ingin membandingkan nilainya secara akurat.
        </div>
      )}
    </div>
  );
}

export default TrenChart;
